import React from 'react'

import { IColumn, PinnedStatus } from './Types'

function isLastColumn(columns: IColumn[], column: IColumn) {
  return columns[columns.length - 1].index === column.index
}

interface IBodySizesProps {
  headers: IColumn[]
  filter: PinnedStatus
  fillerWidth: number
}

export const BodySizes: React.FC<IBodySizesProps> = props => {
  return (
    <colgroup>
      {props.headers.map((header, i) => {
        let widthStyles = {
          maxWidth: header.width,
          minWidth: header.width,
          width: header.width
        }

        if (isLastColumn(props.headers, header)) {
          widthStyles = {
            maxWidth: header.width + props.fillerWidth,
            minWidth: header.width + props.fillerWidth,
            width: header.width + props.fillerWidth
          }
        }

        return (
          <col
            key={i}
            style={{
              ...widthStyles,
              opacity: header.pinned !== PinnedStatus.Center ? 0 : 1
            }}
          />
        )
      })}
    </colgroup>
  )
}

export default React.memo(BodySizes)
